//component entry file
import ManagerTagging from "./components/managerTagging/ManagerTagging.vue";

export default ManagerTagging;